/**
 * Centralized error logger.
 *
 * Today it just forwards to the browser console so DevTools still shows the
 * stack. The single indirection means a future Sentry/PostHog/etc. hook
 * lives in exactly one place — no shotgun edit across 11 files.
 *
 * @param {string} context  Short label (e.g. 'AdminClasses.fetchClasses')
 * @param {unknown} error   The caught error object
 */
export const logError = (context, error) => {
  console.error(`[${context}]`, error);
  // Future: import * as Sentry from '@sentry/react' and call Sentry.captureException(error, { extra: { context } })
};
